"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Overlay = exports.Image = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "inline"],
  _excluded2 = ["className"],
  _excluded3 = ["children", "className", "displayType", "inline", "outside", "position", "shape", "size"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var Overlay = exports.Overlay = function Overlay(_ref) {
  var children = _ref.children,
    className = _ref.className,
    inline = _ref.inline,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: (0, _classnames.default)(className, 'sticker-overlay', {
      'inline-item': inline
    })
  }, otherProps), children);
};
var Image = exports.Image = function Image(_ref2) {
  var className = _ref2.className,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement("img", _extends({
    className: (0, _classnames.default)(className, 'sticker-img')
  }, otherProps));
};
function Sticker(_ref3) {
  var _classNames;
  var children = _ref3.children,
    className = _ref3.className,
    displayType = _ref3.displayType,
    inline = _ref3.inline,
    _ref3$outside = _ref3.outside,
    outside = _ref3$outside === void 0 ? false : _ref3$outside,
    position = _ref3.position,
    shape = _ref3.shape,
    size = _ref3.size,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, otherProps, {
    className: (0, _classnames.default)('sticker', className, (_classNames = {}, _defineProperty(_classNames, "sticker-".concat(shape), shape), _defineProperty(_classNames, "sticker-".concat(displayType), displayType), _defineProperty(_classNames, "sticker-".concat(position), position), _defineProperty(_classNames, "sticker-outside", position && outside), _defineProperty(_classNames, "sticker-".concat(size), size), _classNames))
  }), /*#__PURE__*/_react.default.createElement(Overlay, {
    inline: inline
  }, children));
}
Sticker.Image = Image;
Sticker.Overlay = Overlay;
var _default = exports.default = Sticker;